<template>
  <el-dialog
    class="application-launcher-dialog"
    title="发起申请"
    :visible="visible"
    width="880px"
    :close-on-click-modal="false"
    append-to-body
    @update:visible="$emit('update:visible', $event)"
    @closed="reset"
  >
    <div class="application-launcher-search">
      <el-input
        ref="search"
        v-model="keyword"
        clearable
        prefix-icon="el-icon-search"
        maxlength="100"
        placeholder="搜索费用、付款、借款、开票等申请"
        aria-label="搜索申请"
      />
    </div>
    <nav class="application-launcher-categories" aria-label="申请分类">
        <button type="button" :class="{ active: category === 'all' }" @click="category = 'all'">全部</button>
        <button v-for="item in categories" :key="item" type="button" :class="{ active: category === item }" @click="category = item">{{ item }}</button>
    </nav>

    <div class="application-launcher-body">
      <div v-if="filtered.length" class="application-launcher-grid">
        <button
          v-for="item in filtered"
          :key="item.key"
          type="button"
          class="application-launcher-card"
          :aria-label="'发起' + item.name + (item.beta ? '，Beta 测试阶段' : '')"
          @click="$emit('launch', item)"
        >
          <span class="application-launcher-icon" :class="'oa-tone-' + item.tone"><oa-type-icon :name="item.iconKey" /></span>
          <span class="application-launcher-copy"><strong>{{ item.name }}</strong><span v-if="item.beta" class="application-beta">Beta</span></span>
          <i class="el-icon-arrow-right application-launcher-arrow" />
        </button>
      </div>
      <div v-else class="application-launcher-empty">
        <i class="el-icon-search" />
        <strong>{{ available.length ? '没有找到匹配的申请' : '当前账号暂无可发起的申请' }}</strong>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import OaTypeIcon from './OaTypeIcon'
import { APPLICATIONS, allowed } from '@/utils/oa'
import { expenseSubmissionAccess } from '@/api/crm/expense'

export default {
  name: 'ApplicationLauncherDialog',components:{OaTypeIcon},
  props: { visible: Boolean },
  data() { return { keyword: '', category: 'all', executiveApply: false } },
  computed: {
    permissions() { return this.$store.getters.permissions || [] },
    available() { return APPLICATIONS.filter(item => allowed(this.permissions, item.permission) && (item.key !== 'executiveExpenseClaim' || this.executiveApply)) },
    categories() { return [...new Set(this.available.map(item => item.category))] },
    filtered() {
      const keyword = this.keyword.trim().toLowerCase()
      return this.available.filter(item =>
        (this.category === 'all' || item.category === this.category) &&
        (!keyword || [item.name, item.category, item.keywords].join(' ').toLowerCase().includes(keyword))
      )
    }
  },
  watch: {
    visible(value) {
      this.executiveApply = false
      if (value) {
        const version = this.accessVersion = (this.accessVersion || 0) + 1
        expenseSubmissionAccess().then(r => { if (this.visible && version === this.accessVersion) this.executiveApply = r.data.executiveApply === true }).catch(() => {})
        this.$nextTick(() => this.$refs.search && this.$refs.search.focus())
      } else this.accessVersion = (this.accessVersion || 0) + 1
    },
    categories(items) {
      if (this.category !== 'all' && !items.includes(this.category)) this.category = 'all'
    }
  },
  methods: {
    reset() { this.keyword = ''; this.category = 'all' }
  }
}
</script>

<style lang="scss">
.application-launcher-dialog {
  .el-dialog { max-width:calc(100vw - 32px); border-radius:14px; overflow:hidden; box-shadow:0 24px 72px rgba(31,49,78,.22); }
  .el-dialog__header { padding:24px 28px 19px; border-bottom:1px solid #edf1f6; }
  .el-dialog__title { color:#253247; font-size:21px; font-weight:600; letter-spacing:.2px; }
  .el-dialog__headerbtn { top:25px; right:28px; font-size:19px; }
  .el-dialog__body { padding:22px 28px 30px; }
}
.application-launcher-search { margin-bottom:16px; }
.application-launcher-search .el-input__inner { height:44px; border-color:#dfe6ef; border-radius:8px; background:#f9fbfd; }
.application-launcher-search .el-input__inner:focus { border-color:#7eabf8; background:#fff; box-shadow:0 0 0 3px rgba(68,128,243,.08); }
.application-launcher-search .el-input__prefix { line-height:44px; }
.application-launcher-categories { display:flex; min-width:0; gap:6px; margin-bottom:18px; overflow-x:auto; scrollbar-width:thin; }
.application-launcher-categories button { flex:none; border:1px solid transparent; border-radius:17px; padding:7px 14px; background:#f5f7fa; color:#68758a; font:inherit; font-size:13px; cursor:pointer; white-space:nowrap; transition:color .15s,border-color .15s,background .15s; }
.application-launcher-categories button:hover { color:#4480f3; background:#f1f6ff; }
.application-launcher-categories button.active { border-color:#c9dbfb; color:#276ee8; background:#eaf2ff; font-weight:500; }
.application-launcher-body { max-height:52vh; min-height:194px; overflow-y:auto; padding:2px 5px 4px 2px; }
.application-launcher-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:14px; }
.application-launcher-card { display:flex; min-width:0; min-height:88px; align-items:center; gap:16px; border:1px solid #e3e9f1; border-radius:11px; padding:17px 18px; background:#fff; color:#2f3c51; font:inherit; text-align:left; cursor:pointer; transition:border-color .16s,box-shadow .16s,transform .16s,background .16s; }
.application-launcher-card:hover { border-color:#a9c6fb; background:#fbfdff; box-shadow:0 8px 22px rgba(44,91,166,.1); transform:translateY(-1px); }
.application-launcher-card:focus-visible { outline:2px solid #4480f3; outline-offset:2px; }
.application-launcher-copy {display:flex;flex-direction:column;align-items:flex-start;gap:6px;min-width:0}
.application-beta{display:inline-block;padding:1px 6px;border:1px solid #d9d3f4;background:#f4f1fd;color:#7860b1;font-size:10px;font-weight:600;line-height:16px;border-radius:4px;letter-spacing:.25px}
.application-launcher-card strong { min-width:0; overflow-wrap:anywhere; white-space:normal; line-height:1.5; font-size:15px; font-weight:600; }
.application-launcher-icon { display:flex; width:48px; height:48px; flex:none; align-items:center; justify-content:center; border-radius:13px; color:#4480f3; background:#eaf2ff; font-size:24px; transition:transform .16s; }
.application-launcher-icon.oa-tone-teal{color:#218d83;background:#e8f7f5}.application-launcher-icon.oa-tone-rose{color:#cb627b;background:#fff0f3}
.application-launcher-icon.oa-tone-green { color:#239c77; background:#e7f7f1; }
.application-launcher-icon.oa-tone-orange { color:#d18424; background:#fff2e1; }
.application-launcher-icon.oa-tone-purple { color:#8158da; background:#f1ebff; }
.application-launcher-arrow { margin-left:auto; color:#bbc5d3; font-size:15px; transition:color .16s,transform .16s; }
.application-launcher-card:hover .application-launcher-icon { transform:scale(1.04); }
.application-launcher-card:hover .application-launcher-arrow { color:#4480f3; transform:translateX(2px); }
.application-launcher-empty { display:flex; min-height:180px; flex-direction:column; align-items:center; justify-content:center; gap:13px; color:#8794a7; }
.application-launcher-empty>i { font-size:34px; color:#b6c1d0; }
.application-launcher-empty strong { font-size:15px; font-weight:500; }
@media(max-width:900px) {
  .application-launcher-categories { width:100%; }
}
@media(max-width:520px) {
  .application-launcher-dialog .el-dialog__body { padding:18px; }
  .application-launcher-grid { grid-template-columns:1fr; }
  .application-launcher-card { min-height:82px; padding:15px 16px; }
}
</style>
